// import {
//   defaultSelectedFromDate,
//   defaultSelectedToDate,
// } from "utils/datepicker-util/converters/date";

import { defaultSelectedFromDate, defaultSelectedToDate } from "utils/applicant-util";
import { getDefineds } from "utils/datepicker-util/app-constants/DateDefineds";

export const CHANGE_COMMON_FILTER = "CHANGE_COMMON_FILTER";
export const RESET_COMMON_FILTER = "RESET_COMMON_FILTER";
const getInitialState = () => ({
  start_date: defaultSelectedFromDate(),
  end_date: defaultSelectedToDate(),
  order_by: "create_date",
  disabledDate: false,
});

export default function commonFilterReducer(
  state = getInitialState(),
  action
) {
  switch (action.type) {
    case CHANGE_COMMON_FILTER:
      return {
        ...state,
        ...action.payload,
      };

    case RESET_COMMON_FILTER:
      return getInitialState();

    default:
      return state;
  }
}
